import { Flex, SegmentedControl } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { VideoLibrarySidebarRawFrame } from 'components/sections/video-library/sidebar/keying-framing-tab/raw-frame';
import { VideoLibrarySidebarReleaseTime } from 'components/sections/video-library/sidebar/keying-framing-tab/release-time';
import { t } from 'i18next';
import { useState } from 'react';

enum TabKey {
  ReleaseTime = 'videos.release-time',
  ReleaseFrame = 'videos.release-frame',
  MoundFrame = 'videos.mound-frame',
}

export const VideoLibrarySidebarKnFTab = () => {
  const [activeTab, setActiveTab] = useState(TabKey.ReleaseTime);

  return (
    <ErrorBoundary identifier="VideoLibrarySidebarKnFTab">
      <Flex direction="column" gap="4">
        <SegmentedControl.Root
          size="1"
          value={activeTab}
          onValueChange={(v) => setActiveTab(v as TabKey)}
          style={{ width: '100%' }}
        >
          {Object.values(TabKey).map((o, i) => (
            <SegmentedControl.Item key={`mode-${i}`} value={o}>
              {t(o)}
            </SegmentedControl.Item>
          ))}
        </SegmentedControl.Root>

        {activeTab === TabKey.ReleaseTime && <VideoLibrarySidebarReleaseTime />}

        {activeTab === TabKey.ReleaseFrame && (
          <VideoLibrarySidebarRawFrame
            identifier="VideoLibrarySidebarKnFRelease"
            // verbose
          />
        )}

        {activeTab === TabKey.MoundFrame && (
          <VideoLibrarySidebarRawFrame
            identifier="VideoLibrarySidebarKnFMound"
            isMound
          />
        )}
      </Flex>
    </ErrorBoundary>
  );
};
